import React, { useEffect, useState } from "react";
import { Clock, Navigation } from "lucide-react";
import RideMap from "./RideMap";
import { foodApi } from "../../lib/api";

// Live delivery tracking map + distance/ETA pill. Polls the assigned driver's GPS
// from /orders/{id}/driver-location (works for the customer AND the restaurant).
export default function OrderTrackMap({ orderId, className = "" }) {
  const [loc, setLoc] = useState(null);
  useEffect(() => {
    if (!orderId) return undefined;
    let on = true;
    const load = () => foodApi.driverLocation(orderId).then((d) => { if (on) setLoc(d); }).catch(() => {});
    load();
    const t = setInterval(load, 5000);
    return () => { on = false; clearInterval(t); };
  }, [orderId]);

  if (!loc) return null;
  const restaurant = loc.restaurant_lat != null ? { lat: loc.restaurant_lat, lng: loc.restaurant_lng }
    : (loc.lat != null ? { lat: loc.lat, lng: loc.lng } : null);
  const delivery = loc.delivery_lat != null ? { lat: loc.delivery_lat, lng: loc.delivery_lng } : null;
  const driver = loc.lat != null ? { lat: loc.lat, lng: loc.lng, heading: loc.heading } : null;
  const enRoute = loc.phase === "en_route";

  return (
    <div className={className} data-testid="order-track-map">
      <div className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-brand-50 px-3 py-1.5 text-sm font-semibold text-brand" data-testid="order-track-eta">
        <Clock className="h-4 w-4" />
        {enRoute && loc.eta_min != null ? `Driver ~${loc.eta_min} min from the customer` :
          loc.phase === "picking_up" ? "Driver picking up at your counter" :
          loc.phase === "delivered" ? "Delivered" : "Driver assigned"}
      </div>
      <RideMap pickup={restaurant} drop={delivery} activeDriver={driver} className="h-56 w-full" />
    </div>
  );
}
